export const DO_PAYMENT_POST = "DO_PAYMENT_POST"
export const DO_PAYMENT_POST_SUCCESS = "DO_PAYMENT_POST_SUCCESS"
export const DO_PAYMENT_POST_FAIL = "DO_PAYMENT_POST_FAIL"

export const DO_PAYMENT_SIGN_VOID = "DO_PAYMENT_SIGN_VOID"
export const DO_PAYMENT_SIGN_VOID_SUCCESS = "DO_PAYMENT_SIGN_VOID_SUCCESS"
export const DO_PAYMENT_SIGN_VOID_FAIL = "DO_PAYMENT_SIGN_VOID_FAIL"

export const DO_PAYMENT_SIGN_REFUND = "DO_PAYMENT_SIGN_REFUND"
export const DO_PAYMENT_SIGN_REFUND_SUCCESS = "DO_PAYMENT_SIGN_REFUND_SUCCESS"
export const DO_PAYMENT_SIGN_REFUND_FAIL = "DO_PAYMENT_SIGN_REFUND_FAIL"

export const DO_PAYMENT_POST_API_ERROR = "DO_PAYMENT_POST_API_ERROR"